var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ship-rules-wrap" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "flex-row-between-center title-top" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apply-btn", on: { click: _vm.showDialog } },
            [_vm._v("编辑")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "top-info" },
          [
            _c(
              "el-row",
              {
                staticClass: "row-bg",
                attrs: { type: "flex", justify: "space-between" }
              },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _c("div", { staticClass: "grid-content bg-purple" }, [
                    _vm._v(
                      "\n            店铺接单时间: " +
                        _vm._s(_vm.detail.start_time) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c("div", { staticClass: "grid-content bg-purple-light" }, [
                    _vm._v(
                      "\n            店铺截单时间: " +
                        _vm._s(_vm.detail.end_time) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c("div", { staticClass: "grid-content bg-purple" }, [
                    _vm._v(
                      "\n            周末发货规则: " +
                        _vm._s(_vm.detail.week_end_rule_str) +
                        "\n          "
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gray-bg" }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "padding-top": "8px" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%", "text-align": "center" },
              attrs: { data: _vm.tableData, size: "mini" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "申请单号", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "变更前" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n            店铺接单时间：" +
                              _vm._s(scope.row.before_start_time) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n            店铺截单时间：" +
                              _vm._s(scope.row.before_end_time) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n            周末发货规则：" +
                              _vm._s(scope.row.before_shipping_rule_str) +
                              "\n          "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "变更后" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n            店铺接单时间：" +
                              _vm._s(scope.row.after_start_time) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n            店铺截单时间：" +
                              _vm._s(scope.row.after_end_time) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left" }, [
                          _vm._v(
                            "\n            周末发货规则：" +
                              _vm._s(scope.row.after_shipping_rule_str) +
                              "\n          "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_at", label: "发起时间", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "review_time", label: "审核时间", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applicant_name", label: "申请人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status_str", label: "状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "review_comment", label: "审批备注" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "text-align": "center" },
        attrs: {
          "current-page": _vm.queryInfo.current,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.queryInfo.page_size,
          layout: "total,sizes, prev, pager, next,jumper",
          total: _vm.queryInfo.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function($event) {
            return _vm.$set(_vm.queryInfo, "current", $event)
          },
          "update:current-page": function($event) {
            return _vm.$set(_vm.queryInfo, "current", $event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "ship-rule-dialog",
            title: "编辑规则",
            "append-to-body": "",
            center: "",
            visible: _vm.visible,
            width: "660px",
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            close: _vm.hideDialog
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "rule-edit-form",
              attrs: {
                model: _vm.addForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "start_time", label: "店铺接单时间" } },
                [
                  _c("el-time-picker", {
                    attrs: { format: "HH:mm", placeholder: "接单时间" },
                    model: {
                      value: _vm.addForm.start_time,
                      callback: function($$v) {
                        _vm.$set(_vm.addForm, "start_time", $$v)
                      },
                      expression: "addForm.start_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "end_time", label: "店铺截单时间" } },
                [
                  _c("el-time-picker", {
                    attrs: { format: "HH:mm", placeholder: "截单时间" },
                    model: {
                      value: _vm.addForm.end_time,
                      callback: function($$v) {
                        _vm.$set(_vm.addForm, "end_time", $$v)
                      },
                      expression: "addForm.end_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "周末发货规则", prop: "week_rule" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.addForm.week_rule,
                        callback: function($$v) {
                          _vm.$set(_vm.addForm, "week_rule", $$v)
                        },
                        expression: "addForm.week_rule"
                      }
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1", name: "1" } }, [
                        _vm._v("周六不发")
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "2", name: "2" } }, [
                        _vm._v("周日不发")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c("div", { staticClass: "dialog-tips" }, [
                  _vm._v(
                    "\n          1、平台审核通过后，店铺正常接单，待发货的订单【要求发货日】将按此调整，已发货订单【要求发货日】不受影响。\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dialog-tips m-b-20" }, [
                  _vm._v(
                    "\n          2、若都不选则视为周六日正常发货。\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.visible = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("addForm")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-row-start-center" }, [
      _c("div", { staticClass: "title-left" }, [
        _vm._v("\n          当前店铺发货规则：\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-l-40" }, [
        _c("span", { staticClass: "el-icon-warning c-red" }),
        _vm._v(
          "\n          请注意：商家提交申请后，需平台审核通过才生效。平台审核时效：\n          "
        ),
        _c("span", { staticClass: "c-red" }, [_vm._v("1个工作日")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edaa54cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edaa54cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderReport/shipRules.vue
// module id = null
// module chunks = 